export * from './intermunicipal-insurance.page'
